import React, { useState } from 'react';
import './styles/index.css';
import Page from 'src/components/Page';
import Movements from './movements';

const OrdersView = () => {
  const tabList = ["Pending", "In Progress", "Acknowledgements", "Completed"];
  const [selectedTab, setSelectedTab] = useState("Pending");

  return (
    <Page title="Movements" className="content-container">
      <div className="content-container-wrapper">
        <div className="orders-content-container">
          <div className="orders-tab-list-container">
            {tabList.map((value, index) => (
              <div key={index} className={`orders-tab-list ${selectedTab === value ? "selected" : ""}`} onClick={() => { setSelectedTab(value) }}>{value}</div>
            ))}
          </div>
            <Movements selectedTab={selectedTab} />
        </div>
      </div>
    </Page>
  );
}

export default OrdersView;